import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';

@Directive({
  selector: '[fileModel]'
})
export class AttachmentFileModelDirective implements OnInit, OnDestroy {
  @Output('fileModel') fileSelected = new EventEmitter<File>();

  private changeHandler: () => void;

  constructor ( private el: ElementRef ) {}

  ngOnInit () : void {
    this.changeHandler = () => {
      const file = this.el.nativeElement.files[0];

      this.fileSelected.emit(file);
    };

    this.el.nativeElement.addEventListener('change', this.changeHandler);
  }

  ngOnDestroy () : void {


    this.el.nativeElement.removeEventListener('change', this.changeHandler);


  }

  clear () : void {


    this.el.nativeElement.value = '';


    };


  }
